import React, { useState } from 'react';
import '../App.css';

const FAQ = () => {
  const [openItem, setOpenItem] = useState(null);

  const toggleItem = (index) => {
    if (openItem === index) {
      setOpenItem(null); 
    } else {
      setOpenItem(index); 
    }
  };

  // FAQ data
  const faqItems = [
    {
      question: "How does Picapica Photo Booth work?",
      answer: "Picapica is a web-based photo booth that uses your device's camera to capture a series of 4 photos. After taking your photos, you can customize the photo strip with different colors and frames, then download to share your creation."
    },
    {
      question: "Are my photos stored on your servers?",
      answer: "No. Your privacy is important to us. All photos are processed locally on your device and are not uploaded to our servers. The only exception is when you choose to generate a QR code, where your photo strip is temporarily stored and automatically deleted after 10 minutes."
    },
    {
      question: "Can I use Picapica on my mobile device?",
      answer: "Yes! Picapica works on both desktop and mobile devices with cameras. For the best experience, we recommend using a device with a front-facing camera in a well-lit environment."
    },
    {
      question: "Why can't I retake individual photos?",
      answer: "Just like a traditional photo booth, Picapica is designed to capture spontaneous moments. The countdown timer adds excitement and authenticity to the experience, so each photo session captures a series of 4 consecutive images."
    },
    {
      question: "What filters and frames are available?",
      answer: "We offer several filters including B&W, Sepia, Vintage, Soft, Noir, and Vivid. For frames, you can choose from various colors and themed stickers like Girlypop, Cute, Mofusand, Shin Chan, and Miffy."
    },
    {
      question: "Can I use Picapica for commercial purposes?",
      answer: "Picapica is free for personal use. For commercial usage such as events or business promotions, please contact us through our Contact page."
    },
    {
      question: "My camera isn't working. What should I do?",
      answer: "Please make sure you've granted camera permissions to our website in your browser settings. If you're still having issues, try using a different browser or device. Chrome and Firefox typically work best."
    }
  ];

  return (
    <div className="faq-container">
      <h1>Frequently Asked Questions</h1>
      
      <div className="faq-section">
        {faqItems.map((item, index) => (
          <div 
            key={index} 
            className={`faq-item ${openItem === index ? 'open' : ''}`}
            onClick={() => toggleItem(index)}
          >
            <h3>{item.question}</h3>
            <div className="faq-toggle">
              {openItem === index ? '−' : '+'}
            </div>
            
            {openItem === index && (
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;